import React from "react"
import styled from "styled-components"

const DAMBannerImage = styled.img(`
position: relative;
width: "100%";
aspect-ratio: "6000/230";
@media (orientation: portrait) or (max-width: 800px) {
  aspect-ratio: "5834/667";
}
`)


const DAMBanner = () => {
  return (
    <a
      href="https://imagekit.io/blog/introducing-media-collection-and-sharing/?utm_source=google&utm_medium=organic&utm_campaign=Mediacollection_Launch&utm_content=Website_banner"
      target="_blank"
    >
      <picture
        style={{
          position: "relative",
          top: "0",
          left: "0",
        }}
      >
        <source
          srcSet="https://ik.imagekit.io/ikmedia/Graphics/DAM_ACL_Launch_Graphics/Homepage_Graphic_Assets/ipad_DAM_ACL_homescreen_nMmRB_9IC.png?updatedAt=1684421437598"
          media="(orientation: portrait) or (max-width: 800px)"
          height={667}
          width={5834}
        />
        <DAMBannerImage
          height={230}
          width={6000}
          src="https://ik.imagekit.io/ikmedia/Graphics/DAM_ACL_Launch_Graphics/Homepage_Graphic_Assets/Desktop-DAM_ACL_homescreen_graphic_xjd639CpxI.png?updatedAt=1684223794714"
        />
      </picture>
    </a>
  )
}

export default DAMBanner

